const googleLibPhoneNumber = require('google-libphonenumber');

const phoneUtil = googleLibPhoneNumber.PhoneNumberUtil.getInstance();
const { PhoneNumberType } = googleLibPhoneNumber;

const getPhoneNumberDetails = (inputMobileNumber) => {
  try {
    const phoneNumberObject =
      phoneUtil.parseAndKeepRawInput(inputMobileNumber);

    const e164Number = phoneUtil.format(
      phoneNumberObject,
      googleLibPhoneNumber.PhoneNumberFormat.E164
    );

    const sanitizedInput = inputMobileNumber.replace(/[\s-()]/g, '');

    const regionCode = phoneUtil.getRegionCodeForNumber(phoneNumberObject);

    const numberDetails = {
      countryCode: `+${phoneNumberObject.getCountryCode()}`,
      e164Number,
      isValidNumberForRegion: phoneUtil.isValidNumberForRegion(
        phoneNumberObject,
        regionCode
      ),
      nationalNumber: phoneNumberObject.getNationalNumber().toString(),
      numberType: phoneUtil.getNumberType(phoneNumberObject),
      regionCodeForNumber: regionCode,
      isStrictlyValid: e164Number === sanitizedInput
    };

    return numberDetails;
  } catch (error) {
    return {
      isValidNumberForRegion: false,
      isStrictlyValid: false,
      numberType: -1,
      errorMessage: error.message
    };
  }
};

const isMobileNumberValid = (mobileNumberString) => {
  const numberDetail = getPhoneNumberDetails(mobileNumberString);

  const { numberType, isValidNumberForRegion, isStrictlyValid } = numberDetail;

  const isMobile =
    numberType === PhoneNumberType.MOBILE ||
    numberType === PhoneNumberType.FIXED_LINE_OR_MOBILE;

  return isStrictlyValid && isValidNumberForRegion && isMobile;
};

export default isMobileNumberValid;
